import { User } from './userTypes';

export enum AbsenceType {
    VACATION = 'VACATION',
    SICK_LEAVE = 'SICK_LEAVE',
    DOCTOR = 'DOCTOR',
    PERSONAL_LEAVE = 'PERSONAL_LEAVE',
    UNPAID_LEAVE = 'UNPAID_LEAVE',
    COMPENSATORY_LEAVE = 'COMPENSATORY_LEAVE',
    OTHER = 'OTHER',
}

export enum AbsencePeriod {
    FULL_DAY = 'FULL_DAY',
    HALF_DAY = 'HALF_DAY',
}

export enum AbsenceStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    CANCELLED = 'CANCELLED',
}

export type AbsenceRecord = {
    id: number;
    userId: number;
    companyId: number;
    type: AbsenceType;
    status: AbsenceStatus;
    dateFrom: string;
    dateTo: string;
    period: AbsencePeriod;
    note: string | null;
    requestedBy: number;
    reviewedBy: number | null;
    reviewedAt: string | null;
    reviewNote: string | null;
    createdAt: string;
    updatedAt: string;
    user?: User;
    requester?: User;
    reviewer?: User;
};

export type AbsenceFilter = {
    page?: number;
    perPage?: number;
    userIds?: number[];
    dateFrom?: string;
    dateTo?: string;
    status?: AbsenceStatus;
    type?: AbsenceType;
};

export type CreateAbsenceData = {
    type: AbsenceType;
    dateFrom: string;
    dateTo: string;
    period?: AbsencePeriod;
    note?: string;
    userId?: number;
};

export type UpdateAbsenceData = {
    type?: AbsenceType;
    dateFrom?: string;
    dateTo?: string;
    period?: AbsencePeriod;
    note?: string;
};

export type ReviewAbsenceData = {
    status: AbsenceStatus.APPROVED | AbsenceStatus.REJECTED;
    reviewNote?: string;
};
